import { render } from "./detail.vue?vue&type=template&id=c29701ba&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=c29701ba&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29701ba"]])

export default __exports__